<template>
    <div v-if="schoolId!=null" class="container">
    
            <div class="card">
           
            <div class="card-body">
                    <div class="row justify-content-between my-3">
                        <div class="col"><h4>XXXX Секцийн (Зааx сураx арга зүй) мэдээлэл (<span class="text-primary">{{sekzList.length}}</span>)</h4></div>
                        <div class="col-auto">
                            <button class="btn btn-danger">ЗАС+</button>
                        </div>
                    </div>
        
                    <div class="row">
                        <table class="table table-bordered table-striped">
                            <thead>
                                <th>№</th>
                                <th>Нэр</th>
                                <th>Багшийн тоо</th>
                                <th>Үйлдэл</th>
                            </thead>
                            <tbody>
                                    <tr  v-for="(sekz, index) in sekzList">
                                    <td class="p-0 m-0 font-weight-bold text-center" width="10">{{index+1}}</td>
                                    <td class="p-1 m-0">{{sekz.name}},{{sekz.savedTeachers}}</td>
                                    <td class="p-1 m-0 text-primary font-weight-bold text-center" v-if="sekz.teachers!=undefined&&sekz.teachers!=null&&sekz.teachers.length>0">{{sekz.teachers.length}}</td>
                                    <td class="p-1 m-0 text-center" v-else>0</td>
                                    <td class="p-1 m-0 ">
                                        <span class="badge badge-danger font-weight-normal text-center mr-2" style="font-size:9pt; cursor:pointer" @click="$router.push({name:'CreateSchoolTeacherAddBySector', params:{schoolId:schoolId,sectorId:sekz.id}})">Багш+</span>
                                       
                                        <span v-if="sekz.teachers!=undefined&&sekz.teachers.length>0">
                                            <span v-if="sekz.savedTeachers==true" class="badge badge-success font-weight-normal text-center mr-2" style="font-size:9pt; cursor:pointer">
                                                үүссэн
                                            </span>
                                            <span v-else class="badge badge-danger font-weight-normal text-center mr-2" style="font-size:9pt; cursor:pointer" @click="_saveAllTeacherToFS(sekz)">Үүсгэx+</span>
                                        </span>
                                    </td>
                                </tr>     
                            </tbody>    
                        </table>
                        </div>
            </div>
        </div>
    </div>
    <div v-else class="container"> 
        <div class="alert alert-danger" role="alert">
            This is a danger alert—check it out!
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import moment from 'moment'
    const fb = require('../../firebaseConfig.js')

    export default {
        name: "CreateSchoolTeacherAdd",
        data() {
            return {
                'uploading':false,
                'uploadPercent':null,
                logs:['xx','avac'],
                justCreated:true,
                firstMode:false,
                object:{
                    name:'',
                    shortName:'',
                    description:'',
                    sekzNumber:0,
                    university:false,
                    created:false,
                    level1:true,
                    level2:true,
                    level3:true

                },
                lessonText:null,
                currentSekz: null,
                groupLimit:5,
                teachersText:null,
                teacherList:[],
                sekzText:null,
                sekzList:[
                ],
                classesList:[1,2,3,4,5,6,7,8,9,10,11,12],
                groupList:['а','б','в','г','д','е','ё','ж','з'],
                teachersCreated:false,  
                classData:[],
              
            }
        },
        computed: {
            ...mapState(['userProfile', 'currentUser'])
        },
        methods: {
 
            _createSekz(numberOfSekz){
                //this.teachersCreated = true;
                //TODOX
                var k=0;
                for(const i in this.sekzList){
                    if(numberOfSekz==i) return;
                    var sekz={}
                    if(this.sekzList[i]['default']){
                        console.log(this.sekzList[i]['name'],this.sekzList[i]['default']);
                        sekz['name'] = this.sekzList[i]['name'];
                        sekz.modified=fb.usersCollection.doc(this.$store.getters.currentUser.uid)
                        sekz.modifiedAt=new Date();
                        if(this.schoolId)
                            sekz.school=fb.db.collection("schools").doc(this.schoolId);
                        
                        fb.db.collection("schools/"+this.schoolId+"/sectors").doc().set(sekz)
                        this.logs.push('Секц '+sekz['name'] + ' амжилттай үүслээ.');
                        k++;
                    }
                    if(i==numberOfSekz) break;
                }
                console.log(numberOfSekz,k);
                if(numberOfSekz>k){
                    for(var j=0; j<numberOfSekz-k;j++){
                        var sekz={}
                        sekz['name'] = 'ЗАС-' + (j+1);
                        sekz.modified=fb.usersCollection.doc(this.$store.getters.currentUser.uid)
                        sekz.modifiedAt=new Date();
                        if(this.schoolId)
                            sekz.school=fb.db.collection("schools").doc(this.schoolId);
                        
                        this.logs.push('Секц '+sekz['name'] + ' <нэмэлтээр> амжилттай үүслээ.');
                        fb.db.collection("schools/"+this.schoolId+"/sectors").doc().set(sekz)          
                    }
                }
            },
        
            _inputSekz(sekz){
                $('#inputSekz').modal('toggle');
            },
            _inputTeachers(sekz){
                this.currentSekz= sekz;
                $('#inputTeachers').modal('toggle');
            },
            async _getData(){
                if(this.schoolId!=null){
               
                    var schoolDoc=await fb.db.doc('schools/'+this.schoolId).get();
                    if(schoolDoc.exists){
                        let school=schoolDoc.data();
                        school.id=schoolDoc.id;
                        school.ref=schoolDoc.ref;
                        this.school=school
                        this.teachers=[];
                        this.getSekzdata();
                    }
                } else{
                    console.log('dddd');
                }
            },
    
            async getSekzdata(){
                var _this=this;
                var docs=fb.db.collection("schools/"+this.schoolId+"/sectors").get().then(
                    function(querySnapshot) {
                        querySnapshot.forEach(function(doc) {
                        let object=doc.data();
                        object.id = doc.id;
                        console.log(_this.sekzList);
                        _this.sekzList.push(object);
                    });
                });
            },
        },
        props: {
            schoolId:{
                requered:true
            }
        },
        created() {
            this._getData();
        },
        filters: {
            formatDate(val) {
                if (!val) { return '-' }
                let date = val.toDate()
                return moment(date).fromNow()
            },
            trimLength(val) {
                if (val.length < 200) { return val }
                return `${val.substring(0, 200)}...`
            }
        }
    }
</script>

<style scoped>
.numberIsNOTGiven{
    background-color: #ED3D63!important;
    color:white!important;
}
.numberIsGiven{
    background-color: green!important;
    color:white!important;
}
</style>